import React from 'react';
import { Route } from 'react-router-dom';
import { CommonModule } from "uca-react-containers-library";

function PrivateRoute({ component: Component, title, banner, ...rest }) {
    document.title = `${title} | ${banner}`;
    return (
        <CommonModule.AuthProvider>
            <CommonModule.RouteProvider>
                <Route {...rest} render={props => <Component {...props} />} />
            </CommonModule.RouteProvider>
        </CommonModule.AuthProvider>
    );
}

export default PrivateRoute;